import classNames from "classnames";
import React from "react";
import { c } from "ttag";

import { Image } from "../../../common/Image";
import { IProduct } from "../../../models/catalogue.interfaces";

interface IProps {
    rootProduct: IProduct;
    isSelected: boolean;
    onClick: () => void;
}

interface IState {}

// TODO(ssr, LEVEL 1 out of 10): Migrate this component from class-style to functional-style. Rated LOE as 1/10 due to 45 LOC, simple presentational component with image filtering and button rendering. Trivial migration.
export class GiftThumbnail extends React.Component<IProps, IState> {
    render() {
        const image = this.props.rootProduct.images.filter((img) => {
            return img.role === "Product Tile";
        })[0];
        if (!image) {
            console.error(
                `Tile image is missing for product ${this.props.rootProduct.title}`,
            );
            return null;
        }
        const thumbnailClasses = classNames({
            "gift-thumbnail": true,
            "gift-thumbnail--selected": this.props.isSelected,
        });
        const altText = c("GiftThumbnail")
            .t`Select ${this.props.rootProduct.title}`;
        return (
            <li className={thumbnailClasses}>
                <button
                    type="button"
                    title={altText}
                    onClick={this.props.onClick}
                >
                    <Image src={image.original} alt={altText} />
                </button>
            </li>
        );
    }
}
